import React, { useState, useEffect } from 'react';
import { Icon, Text } from '../../Atoms';
import { Input } from '../../Molecules';
import PropTypes from 'prop-types';

const OrganismInputSimple = (props) => {
  const [edit, setEdit] = useState(false);
  const [firstValue, setFirstValue] = useState('');
  const classNameInput = [];
  if (props.classNameInput) {
    classNameInput.push(`${props.classNameInput}`);
  }
  useEffect(() => {
    setFirstValue(props.value);
    props.edit && setEdit(props.edit);
  }, []);

  const cancelEdit = () => {
    onChangeEditMode();
    // props.onChange(firstValue)
  };

  useEffect(() => {
    if (props.edit != undefined) {
      // onChangeEditMode(props.edit);
      setEdit(props.edit);
    }
  }, [props.edit]);

  const onChangeEditMode = (value = !edit) => {
    if (props.handelEditMode) {
      props.handelEditMode(value);
      setEdit(props.edit);
    } else {
      setEdit(value);
    }
  };
  return (
    <div className="input-profile-container-margin">
      <Input
        value={props.value}
        placeholder={props.label}
        className={classNameInput.join(' ')}
        onChange={(e) => props.onChange(e.target.value)}
        as={props.as}
        customClass={props.customClass}
        autoCompleteOption={props.autoCompleteOption}
        autoCompleteOptionClicked={props.autoCompleteOptionClicked}
        showDropDown={props.showDropDown}
        autoCompleteClickAway={props.autoCompleteClickAway}
      />
    </div>
  );
};
OrganismInputSimple.defaultProps = {
  as: 'input',
  autoCompleteOption: [],
  autoCompleteOptionClicked: null,
  autoCompleteClickAway: null,
  showDropDown: false
};
OrganismInputSimple.PropTypes = {
  as: PropTypes.string,
  autoCompleteOption: PropTypes.array,
  autoCompleteOptionClicked: PropTypes.any,
  autoCompleteClickAway: PropTypes.any,
  showDropDown: false
};
export default OrganismInputSimple;
